<script>
import NavOnboarding from '@components/accountsManager/nav-onboarding.vue';
import LoginDesktop from '@views/accountsManager/desktop/login-desktop.vue';
import LoginMobile from '@views/accountsManager/mobile/login-mobile.vue';

import { breakpointsMixin } from '@mixins/breakpointsMixin';
import {
  orgComputed,
  orgMethods,
} from '@state/helpers';

export default {
  name: 'Login',
  mixins: [breakpointsMixin],
  components: {
    NavOnboarding,
    // eslint-disable-next-line vue/no-unused-components
    LoginDesktop,
    LoginMobile,
  },
  data() {
    return {
      email: '',
      password: '',
    };
  },
  mounted() {
    if (this.isDesktopView) {
      this.show();
    }
  },
  destroyed() {
    this.hide();
  },
  methods: {
    ...orgMethods,
    show() {
      this.$bvModal.show('login-modal');
    },
    hide() {
      this.$bvModal.hide('login-modal');
    },
  },
  watch: {
    isDesktopView(val) {
      if (val) {
        this.show();
      } else {
        this.hide();
      }
    },
  },
  computed: {
    ...orgComputed,
    cssVars() {
      return {
        '--background':  'url('+this.backgroundImg + ') center no-repeat'
      }
    }
  },
};
</script>

<template>
  <div>
    <div v-show="isDesktopView" class="desktop" :style="cssVars">
      <NavOnboarding />
      <b-modal id="login-modal" size="lg" centered no-close-on-backdrop no-close-on-esc hide-footer hide-header>
        <LoginDesktop />
      </b-modal>
      <div class="desktop">
        <NavOnboarding />
      </div>
    </div>
    <div class="mobile" v-show="!isDesktopView">
      <LoginMobile />
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

// stylelint-disable selector-pseudo-element-no-unknown

* {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

::v-deep .modal-dialog {
  max-width: 500px;
  width: 40%;
}
::v-deep .modal-content {
  border-radius: 8px;
}
.desktop {
  background: var(--background);
  background-size: cover;
  display: flex;
  height: 100%;
  opacity: 0.98;
  position: absolute;
  width: 100%;
}

.mobile {
  display: flex;
  height: 100%;
  position: absolute;
  width: 100%;
}
</style>
